export default __webpack_public_path__ + "static/media/ABout_Comp_CommonMenu.396ed5ac.svg";